import { ActionTypeKeys, ActionTypes } from 'common/actions'
import { Config } from 'even-ts-static'

export const initialConfigState: Readonly<Config> = {}

const reducer = (state: Config = initialConfigState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.LOAD_CONFIG_SUCCESS:
      return { ...state, ...action.config }
    case ActionTypeKeys.UPDATE_CONFIG_STEP:
      return {
        ...state,
        step: action.step,
      }
    default:
      return state
  }
}

export default reducer
